export const REGISTER_PATHNAME = '/register';
